/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.controllers {
    export interface ICleanDatabaseScope extends angular.IScope {
        cleanDatabase() : void
    }

    export class CleanDatabaseController implements IController {
        private scope: ICleanDatabaseScope;
        private $http: ng.IHttpService;

        constructor(
            scope: ICleanDatabaseScope,
            $http: ng.IHttpService)
        {
            this.scope = scope;
            this.$http = $http;
            this.scope.cleanDatabase = () => this.cleanDatabase();
        }

        private cleanDatabase(): void {
            this.$http.get('./api/Test/CleanDatabase')
        }
    }
}

warsApp.registerController('CleanDatabaseController', ['$scope', '$http']);